/** 
 * Accordion controller
 * Controls the toggling of the accordion and the loading of content on it
 */

function AccordionSetup() {

  var animationDuration = 150; // ms
  /* 
   * Start setup
   */
  $(document).ready(function() {
    setupAccordionButtons();
    setupAllReplyListeners();
    setupAllDeleteListeners();
    setupMoreCommentsListener();
    setupFirstToCommentMessage();
  });
  /* End setup */

  /*
   * Main setup functions
   */

  function setupAccordionButtons() {
    /* Buttons show the accordion and target content is shown */
    var $accordionButtons = $('.mobile-accordion-button');
    $accordionButtons.each(function() {
      var $button = $(this);
      $button.click(function() {
        openAccordion({
          title:  $button.data('title'),
          targetContent: $button.data('target'),
        });
      });
    });
  }

  function setupAllReplyListeners() {
    /* Set reply listeners for comments */
    $('.accordion-item-reply').each(function() {
      var $this = $(this);
      $this.click( function(event) {
        event.preventDefault();
        var login = $this.data('user');
        
        // Add tag to input value
        var $input = $('#accordion-form-input');
        $input.val( '@' + login + ' ' + $input.val());
        $input.focus();
      })
    });
  }

  function setupAllDeleteListeners() {
    /* Set delete listeners for comments */
    $('.accordion-item-delete').each(function() {
      setupDeleteListener($(this));
    });
  }

  function setupDeleteListener($link) {
    $link.click( function(event) {
      event.preventDefault();
      // <li> element (container) and commentId are passed as arguments
      openDeleteCommentDialog({
        $container: $link.parents('.accordion-item'),
        commentId: $link.data('comment')
      });
    })
  }

  function setupMoreCommentsListener () {
    $('#accordion-more-comments').click(function(event) {
      event.preventDefault();

      var commentCount = $('#comments').find('li').length;
      var key = slideshare_object.comments.get_secret_key();
      var params = { 'key': key, 'offset': commentCount  };

      $.getJSON(slideshare_object.comments.ajaxurl, params, function(comments) {
        if(comments) {
          comments.forEach(function(comment){
            // Render new comment for each element in array
            appendNewComment(comment, false);
          });

          if(comments.length < 10) {
            // Delete 'show more' button
            // TODO: Actually this information should come from the server,
            // when exactly 5 comments are fetched
            $('#accordion-more-comments').remove();
          }
        }
      });
    });
  }

  function setupFirstToCommentMessage () {
    var commentCountCache = $('#comments').find('li').length;
    var isLoggedIn = slideshare_object.user.loggedin;

    if (commentCountCache !== 0 || !isLoggedIn) {
      $('.j-first-to-comment').hide();
    }
  }

  /* 
   * Open and close accordion main actions
   */
  function openAccordion (options) {
    setTitle(options.title);
    showAccordion();
    showCommentsForm(options.targetContent);
    showTargetContent(options.targetContent);
    setCloseButtonListener(options.targetContent);
    if (options.title.toLowerCase() === 'comments') setCommentsPostListener();
  }

  function closeAccordion (targetContent) {
    hideAccordion();
    hideTargetContent(targetContent);
  }

  //

  function setTitle(title) {
    $('#accordion-title').text(title);
  }
  
  function showAccordion() {
    $('html').addClass('accordion-open');
  }
  
  function showCommentsForm(targetContent) {
    if (targetContent === "comments") $('#accordion-form').css('display', 'flex');
    else $('#accordion-form').css('display', 'none');
  }

  function showTargetContent(targetContent) {
    $('#'+targetContent).show(0);
  }

  function setCloseButtonListener(targetContent) {
    /* Close button hides the accordion and hides target content */
    $('#accordion-close').on('click', function() {
      closeAccordion(targetContent);
      $(this).off('click');
    });
  }

  //

  function hideAccordion() {
    $('html').removeClass('accordion-open');
  }

  function hideTargetContent(targetContent) {
    $('#'+targetContent).hide(0);
  }

  /*
   * Comment submission & deletion AJAX
   */

  function setCommentsPostListener() {
    var $commentInput = $('#accordion-form-input');
    var $submitButton = $('#accordion-form-submit');
    $submitButton.off('click');
    $submitButton.on('click', function(event) {
      event.preventDefault();
      var formData = {
        'comment[text]': $commentInput.val(),
        'followup_subscribe': 1,
        'key': slideshare_object.comments.get_secret_key(),
        'slide_order': slideshare_object.comments.slide_number,
        'slide_id': slideshare_object.presentationId,
        'version': 2
      };

      $.post('/comment/create', formData, function(responseData) {
        $commentInput.val('');
        appendNewComment(responseData, true);        

        // Update comment counter
        var $commentCount = $('.j-comment-count');
        var commentCount = parseInt($commentCount.text());
        $commentCount.text(commentCount + 1);

        // If this is the first comment, hide 'Be the first to comment' notice
        if (commentCount === 0) {
          $('.j-first-to-comment').hide();
          $('#accordion-more-comments').hide();

        }
      })
    })
  }

  function deleteComment(options) {
    // options = { $container, commentId }
    
    $.post(slideshare_object.comments.destroy_url, { id: options.commentId }, function(responseData) {
      /* 
      * Animation
      */
      options.$container.css({
        'max-height': options.$container.height() + 'px',
      });

      // Update comment counter
      var $commentCount = $('.j-comment-count');
      var commentCount = parseInt($commentCount.text());
      $commentCount.text(commentCount - 1);

      // If the deleted comment was the only comment, show
      // 'Be the first to comment' notice
      // If this is the first comment, hide 'Be the first to comment' notice
      if (commentCount === 1) {
        $('.j-first-to-comment').show();
        $('#accordion-more-comments').hide();
      } 

      // Small hack so that animation works
      setTimeout(function() {
        options.$container.css({
          'margin-top': '0px',
          'max-height': '0px'
        });
        // Delete element after animation completes
        setTimeout(function() {
          options.$container.remove();
        }, animationDuration);
      }, 10);
    });
  }

  /*
   * Comment DOM handling
   */

  function appendNewComment(responseData, isNewComment) {
    var photoUrl, userName, text
    if(responseData.user) {
      photoUrl = responseData.user.photo_url;
      userName = responseData.user.login;
      text = responseData.text;
    }
    else {
      photoUrl = responseData.photo_url;
      userName = responseData.login;
      text = responseData.body;
    }

    var $list = $('#comments');
    var $newComment = $("<li class='accordion-item'></li>");

    /* Create wrappers */
    var $photoWrapper = $("<div class='accordion-item-photo'></div>");
    var $contentWrapper = $("<div class='accordion-item-content'></div>");
    $newComment.append($photoWrapper);
    $newComment.append($contentWrapper);

    /* Set photo */
    $photoWrapper.append($("<img src='" + photoUrl + "' />"));

    /* Create content header */
    var $contentHeader = $("<header class='accordion-item-header'></header>");
    $contentWrapper.append($contentHeader);
    var $title = $("<h4 class='accordion-item-title'></h4>");
    var $date = $("<span></span>");
    $title.text(userName);
    $date.text(formattedDate());
    $contentHeader.append($title).append($date);

    /* Create content text */
    var $contentText = $("<p class='accordion-item-text'></p>");
    $contentText.html(text);
    $contentWrapper.append($contentText);

    /* Create delete link and add listeners */
    var $deleteLink = $('<a href="#">Delete</a>');
    $deleteLink.addClass('accordion-item-delete');
    $deleteLink.attr('data-comment', responseData.id);
    $contentWrapper.append($deleteLink);
    setupDeleteListener($deleteLink);

    if(isNewComment) {
      /* If loading new comment, scroll top, append, and animate */
      $list.parent().scrollTop(0);
      $list.prepend($newComment);   

      var commentHeight = $newComment.height();
      $newComment.css({ 
        'max-height': '0px',
        'margin-top': '0px'
      });

      // Small hack so that animation works
      setTimeout(function() {
        $newComment.css({
          'max-height': commentHeight + 'px',
          'margin-top': '15px'
        });
        setTimeout(function() {
          $newComment.removeAttr('style');
        }, animationDuration);
      }, 10);
    }
    else {
      /* If it isn't a new comment, it means it comes from 'Show more' action */
      $('#accordion-more-comments').before($newComment);
    }
  }

  function openDeleteCommentDialog(options) {
    // options = { $container, commentId }
    var $deleteDialog = $("<div class='accordion-item-delete-dialog'></div>");
    options.$container.append($deleteDialog);

    var $confirmButton = $('<button data-id="">'+ slideshare_object.deleteComment.accept+'</button>');
    var $declineButton = $('<button>'+ slideshare_object.deleteComment.decline+'</button>');

    $deleteDialog.append($('<h4>'+slideshare_object.deleteComment.deleteCommentConfirmation+'</h4>'));
    $deleteDialog.append($confirmButton);
    $deleteDialog.append($declineButton);

    $confirmButton.on('click', function() {
      // Disable multiple clicks
      $confirmButton.off('click');
      deleteComment(options);
    });

    $declineButton.click(function() {
      $deleteDialog.css('opacity', '0');
      setTimeout(function() {
        $deleteDialog.remove();
      }, animationDuration);
    });
  }

  //

  function formattedDate() {
    var currentDate = new Date();
    var months = ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'May.', 'Jun.', 'Jul.',
      'Aug.', 'Sep.', 'Oct.', 'Nov.', 'Dec.'];

    return months[currentDate.getMonth()] + '' + currentDate.getDate() + ', ' + currentDate.getFullYear();
  }
}

AccordionSetup();
